import jsPDF from "jspdf";
import { Listes } from "../Types/Listes";
import { formatDateHeure } from "./DataAction";
import { useAuth } from "./AuthContext";

export const generateSinglePDF = async (b: Listes) => {
    const MettreformatDateHeure = (d: any): string => {
        return formatDateHeure(d);
    }
    const doc = new jsPDF("landscape", "mm", "A5");
    const pageWidth = doc.internal.pageSize.getWidth();

    const loadImageAsBase64 = async (url: string): Promise<string> =>
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result as string);
                    reader.readAsDataURL(blob);
                });
            });

    const logoBase64 = await loadImageAsBase64("/dagodis.png");

    doc.addImage(logoBase64, "PNG", pageWidth / 2 - 25, -2, 50, 40);
    doc.setFontSize(10);
    doc.text(`Antananarivo, le  ${MettreformatDateHeure(new Date())}`, pageWidth / 2, 30, { align: "center" });
    // doc.setLineWidth(0.5);
    // doc.line(10, 35, pageWidth - 10, 35);
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(`BORDEREAU D'EXPÉDITION N° ${b.NumberBordereau}`, pageWidth / 2, 45, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.rect(10, 50, pageWidth - 20, 30);

    doc.text(`DOIT : ${b.Destinataire || "-"}`, 15, 58);
    doc.text(`${b.Nombres} Colis et ${b.Nombrepack} Pack(s)`, 15, 66);
    // doc.text(`Nombre(s) : ${b.Nombres || "-"}`, 90, 66);
    doc.text(`${b.Bon || "-"}`, 15, 74);

    let yStart = 90;
    // doc.setFontSize(12);
    // doc.setFont("helvetica", "bold");
    // doc.text(`Livreur : ${b.Livreur || "-"}  `, 15, yStart);


    yStart += 10;
    const columnWidth = (pageWidth - 40) / 3;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setDrawColor(150);

    doc.rect(15, yStart, columnWidth, 32);
    doc.text("Expéditeur", 17, yStart + 6);
    doc.setFont("helvetica", "normal");
    doc.text(`${b.Expediteur || ""}`, 17, yStart + 15);

    doc.setFont("helvetica", "bold");
    doc.rect(20 + columnWidth, yStart, columnWidth, 32);
    doc.text("Chauffeur (signature et nom)", 22 + columnWidth, yStart + 6);
    doc.setFont("helvetica", "normal");
    doc.text(`${b.Chaffeur || ""}`, 22 + columnWidth, yStart + 15);
    doc.setFontSize(10);


    doc.setFont("helvetica", "bold");
    doc.rect(25 + columnWidth * 2, yStart, columnWidth, 32);
    doc.text("Transporteur", 27 + columnWidth * 2, yStart + 6);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.text(`Véhicule : ${b.Vehicule || ""}`, 27 + columnWidth * 2, yStart + 15);
    doc.text(`Tel : ${b.Telephone || ""}`, 27 + columnWidth * 2, yStart + 22);
    doc.text(`Coop : ${b.Cooperative || ""}`, 27 + columnWidth * 2, yStart + 29);

    doc.setFontSize(9);
    doc.setTextColor(120);
    doc.text("Document généré par le système DAGODIS", pageWidth / 2, yStart + 40, { align: "center" });

    window.open(doc.output("bloburl"), "_blank");
};